import axios from 'axios';
import { getToken } from './auth';
import { notify } from '../utils/alertBus';

const API_URL = 'https://backend.chamafruits.com';

const withAuth = () => ({
    headers: { Authorization: `Bearer ${getToken()}` },
    withCredentials: true,
});

export const sendPrintRequest = async (branchId, purchaseId) => {
    try {
        const response = await axios.post(
            `${API_URL}/print/${branchId}`,
            { purchaseId },
            withAuth()
        );
        return response.data;
    } catch (error) {
        console.log(error.message);
        console.error('Error sending print request:', error);
        notify("Algo salió mal al enviar la solicitud de impresión. Por favor, inténtalo de nuevo.");
    } 
}


